const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');
const { formatText } = require('core/i18n').i18n;
const FormattedDescription = require('components/commons/FormattedDescription');
const TabbedBoxContent = require('components/commons/tabbedBox/tabbedBoxContent/tabbedBoxContent');
const { rangeSelected: profitabilityRangeSelected } = require('../../actions/profitability');
const { optionSelected: profitRiskOptionSelected } = require('../../actions/profitRisk');
const CumulativeReturnTable = require('components/charts/CumulativeReturnTable/CumulativeReturnTable');
const RiskProfitTable = require('components/charts/RiskProfitTable/RiskProfitTable');
const ProfitabilityChart = require('components/charts/ProfitabilityChart/ProfitabilityChart');
const {
    getProfitabilityData,
    getProfitabilityBenchmark,
    getRiskStatistics,
    getTrailingPerformance,
    getTrailingPerformanceBenchmark,
} = require('../../selectors/fundDataSelectors');
require('./TabProfitability.scss');
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling'
const { FUND_GLOSSARY } = require('constants/flagBasedFeatures')

const TabProfitability = ({
    fund,
    profitabilityBenchmark,
    profitabilityData,
    profitRiskOption,
    riskStatistics,
    selectProfitRiskOption,
    trailingPerformance,
    trailingPerformanceBenchmark,
    flagBasedFeatures
}) => {

    const labelSearchName = flagBasedFeatures.get(FUND_GLOSSARY)
        ? <FormattedDescription value="fundsCard-liquidatingValuesInfo" />
        : <FormattedDescription value="fundsCard-updatedInformationDisclaimerNoGlossary" />

    return (
        <TabbedBoxContent visible>
            <div className="tab-profitability">
                {profitabilityBenchmark &&
                <section className="row tab-profitability__profitability">
                    <div className="col-md-12 col-xs-12">
                        <h3 className="tab-profitability--title">
                            {formatText('fundsCard-profitabilityTitle')}
                        </h3>
                        <ProfitabilityChart
                            benchmark={profitabilityBenchmark}
                            data={profitabilityData}
                            fund={fund}
                        />
                        <aside className="tab-profitability--description text-center">
                            <FormattedDescription value="fundsCard-profitabilityDisclaimer"/>
                        </aside>
                    </div>
                </section>
                }
                <section className="tab-profitability__cumulative-return row">
                    <div className="col-md-12 col-xs-12">
                        <h3 className="tab-profitability--title mt--50">
                            {formatText('fundsCard-cumulativeReturnTitle')}
                        </h3>
                        <p className="tab-profitability--description">
                            <FormattedDescription value="fundsCard-cumulativeReturnDescription"/>
                        </p>
                    </div>
                    {trailingPerformanceBenchmark.trailingPerformance &&
                    <div className="col-md-12 col-xs-12 full-width">
                        <div className="table--reverse">
                            <CumulativeReturnTable
                                benchmark={trailingPerformanceBenchmark}
                                data={trailingPerformance}
                            />
                        </div>
                    </div>
                    }
                </section>
                <section className="tab-profitability__risk-profit row">
                    <div className="col-md-12 col-xs-12">
                        <h3 className="tab-profitability--title mt--50">
                            {formatText('fundsCard-profitAnalysisTitle')}
                        </h3>
                        <p className="tab-profitability--description">
                            <FormattedDescription value="fundsCard-profitAnalysisDescription"/>
                        </p>
                    </div>
                    <div className="col-md-8 col-xs-12">
                        <RiskProfitTable
                            className="tab-profitability__risk-profit__table"
                            data={riskStatistics}
                            onRowActioned={option => selectProfitRiskOption(option)}
                            selected={profitRiskOption}
                        />
                    </div>
                    <div className="col-md-4  arrow__box">
                        <aside className="tab-profitability__risk-profit__option-explained">
                            <span
                                className="box-indicator"
                                style={{top: -10 + 55 * (profitRiskOption + 1) - (55 / 2) - profitRiskOption}}
                            />
                            <article style={{display: profitRiskOption === 0 ? 'block' : 'none'}}>
                                <h4 className="tab-profitability--title risk--profit__option--title">
                                    {formatText('fundsCard-sharpeRatiosTitle')}
                                </h4>
                                <p className="tab-profitability--description">
                                    {formatText('fundsCard-sharpeRatiosDescription')}
                                </p>
                            </article>
                            <article style={{display: profitRiskOption === 1 ? 'block' : 'none'}}>
                                <h4 className="tab-profitability--title risk--profit__option--title">
                                    {formatText('fundsCard-volatilityTitle')}
                                </h4>
                                <p className="tab-profitability--description">
                                    {formatText('fundsCard-volatilityDescription')}
                                </p>
                            </article>
                            <article style={{display: profitRiskOption === 2 ? 'block' : 'none'}}>
                                <h4 className="tab-profitability--title risk--profit__option--title">
                                    {formatText('fundsCard-positiveMonthsTitle')}
                                </h4>
                                <p className="tab-profitability--description">
                                    {formatText('fundsCard-positiveMonthsDescription')}
                                </p>
                            </article>
                            <article style={{display: profitRiskOption === 3 ? 'block' : 'none'}}>
                                <h4 className="tab-profitability--title risk--profit__option--title">
                                    {formatText('fundsCard-negativeMonthsTitle')}
                                </h4>
                                <p className="tab-profitability--description">
                                    {formatText('fundsCard-negativeMonthsDescription')}
                                </p>
                            </article>
                        </aside>
                    </div>
                </section>
                <section className="row">
                    <div className="col-md-12 col-xs-12 tabfees__information">
                        <p className="information__card information__card--footer">
                            {labelSearchName}
                        </p>
                    </div>
                </section>
                <section className="row">
                    <div className="col-md-12 col-xs-12 tabfees__information">
                        <p className="information__profitability">
                            <FormattedDescription value="fundsCard-profitabilityInformation" />
                        </p>
                    </div>
                </section>
            </div>
        </TabbedBoxContent>
    );
}

TabProfitability.propTypes = {
    currentYear: PropTypes.number.isRequired,
    fund: PropTypes.object.isRequired,
    inceptionYear: PropTypes.number.isRequired,
    profitabilityBenchmark: PropTypes.object.isRequired,
    profitabilityData: PropTypes.array,
    profitabilityMinYear: PropTypes.number,
    profitRiskOption: PropTypes.number.isRequired,
    riskStatistics: PropTypes.object.isRequired,
    selectProfitabilityRange: PropTypes.func.isRequired,
    selectProfitRiskOption: PropTypes.func.isRequired,
    trailingPerformance: PropTypes.object.isRequired,
    trailingPerformanceBenchmark: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired
};

TabProfitability.propTypes = {
    profitabilityData: [],
};

const mapStateToProps = (state, props) => ({
    currentYear: moment().year(),
    inceptionYear: moment(props.fund.inceptionDate).year(),
    profitabilityBenchmark: getProfitabilityBenchmark(state, props),
    profitabilityData: getProfitabilityData(state, props),
    profitabilityMinYear: state.brokerInvestmentFundView.profitabilityMinYear,
    profitRiskOption: state.brokerInvestmentFundView.profitRiskOption,
    riskStatistics: getRiskStatistics(state, props),
    trailingPerformance: getTrailingPerformance(state, props),
    trailingPerformanceBenchmark: getTrailingPerformanceBenchmark(state, props),
});

const mapDispatchToProps = dispatch => ({
    selectProfitabilityRange: minYear => dispatch(profitabilityRangeSelected({ minYear })),
    selectProfitRiskOption: option => dispatch(profitRiskOptionSelected({ option })),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(withFeatureToggling(TabProfitability));
